import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { propStr } from '../../../helpers/custom-prop-types';
const DirectoryPlusIcon = ({ className }) => (_jsxs("svg", Object.assign({ className: clsx('svg-directory-plus-icon', className), fill: 'none', height: '26', viewBox: '0 0 28 26', width: '28', xmlns: 'http://www.w3.org/2000/svg' }, { children: [_jsx("path", { d: 'M23.375 15.75H21.5V19.5H17.75V21.375H21.5V25.125H23.375V21.375H27.125V19.5H23.375V15.75Z', fill: '#8E8E8E' }), _jsx("path", { d: 'M25.25 4.5H14L10.8125 1.3125C10.4375 0.9375 9.96875 0.75 9.5 0.75H2.75C1.71875 0.75 0.875 1.59375 0.875 2.625V21.375C0.875 22.4062 1.71875 23.25 2.75 23.25H15.875V21.375H2.75V2.625H9.5L12.6875 5.8125L13.25 6.375H25.25V13.875H27.125V6.375C27.125 5.34375 26.2812 4.5 25.25 4.5Z', fill: '#8E8E8E' })] })));
DirectoryPlusIcon.propTypes = {
    className: propStr(),
};
DirectoryPlusIcon.defaultProps = {
    className: '',
};
export default DirectoryPlusIcon;
